import { z } from "zod"
import { Element } from "../element"

// Version 1 ---------------------
export const ModalElementV1 = z.object({
  id: z.string(),
  name: z.literal("modal"),
  children: z.lazy(() => z.array(Element)),
})

export type TModalElementV1 = z.infer<typeof ModalElementV1>

// Latest ---------------------
export const ModalElement = ModalElementV1
export type TModalElement = TModalElementV1
